import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";

var _dec, _class, _class2, _temp;

/*
|-------------------------------------------------------------------------------
| Select Menu
|-------------------------------------------------------------------------------
|
| The following compound component attempts to implement a number of core
| select behaviours:
|
|  - Render all given options
|  - Click / touch options for selection
|  - Sane defaults for touch behaviours
|
*/
import { styled, StyleSheet } from '@rexlabs/styling';
import React, { Component } from 'react';
import zenscroll from 'zenscroll';
import { autobind } from 'core-decorators';
import Types from 'prop-types';
import _ from 'lodash';
import { ComponentPropType, SelectModelPropType } from '../utils/custom-prop-types';
import KEY_CODES from '../utils/key-codes';
import selectController from './controller-hoc';
import Option from './option';

var getLabel = function getLabel(obj) {
  return obj.label;
};

var NOT_FOUND_OPTION = {
  label: 'No results found',
  value: ''
}; // eslint-disable-next-line react/prop-types

var OptionNotFound = function OptionNotFound(_ref) {
  var pluckLabel = _ref.pluckLabel;
  return React.createElement(Option, {
    isPassive: true,
    index: -1,
    option: NOT_FOUND_OPTION,
    pluckLabel: getLabel
  });
};

var OptionSelected = function OptionSelected(_ref2) {
  var props = _Object$assign({}, _ref2);

  return React.createElement(Option, _extends({}, props, {
    isSelected: true
  }));
};

var subscribers = [];
var subscription = null;

var subscribeToOuterClick = function subscribeToOuterClick(subscriber, listeners) {
  subscribers = _concatInstanceProperty(subscribers).call(subscribers, subscriber);

  var unsubscribe = function unsubscribe() {
    subscribers = _filterInstanceProperty(subscribers).call(subscribers, function (sub) {
      return sub !== subscriber;
    });

    if (!subscribers.length) {
      _forEachInstanceProperty(listeners).call(listeners, function (listener) {
        listener && listener.removeEventListener('mousedown', subscription);
      });

      subscription = null;
    }
  };

  if (!subscription) {
    subscription = function subscription(event) {
      return _forEachInstanceProperty(subscribers).call(subscribers, function (sub) {
        return sub(event);
      });
    };

    _forEachInstanceProperty(listeners).call(listeners, function (listener) {
      listener && listener.addEventListener('mousedown', subscription);
    });
  }

  return unsubscribe;
};

var SelectMenu = (_dec = styled(StyleSheet({
  container: {
    position: 'absolute',
    width: '100%',
    zIndex: 1000,
    maxHeight: '25vh',
    border: 'solid 1px grey',
    outline: 'none',
    borderTop: 'none',
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5,
    background: 'white',
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    overflowY: 'scroll'
  }
})), selectController(_class = _dec(_class = autobind(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(SelectMenu, _Component);

  function SelectMenu(props) {
    var _getPrototypeOf2, _context;

    var _this;

    _classCallCheck(this, SelectMenu);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectMenu)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context = [this, props]).call(_context, args)));

    if (props.shouldCloseOnOuterClick) {
      _this.unsubscribeFromOuterClick = subscribeToOuterClick(_this.handleOuterClick, props.outerClickListeners);
    }

    return _this;
  }

  _createClass(SelectMenu, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.shouldCloseOnOuterClick) {
        this.unsubscribeFromOuterClick();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref3) {
      var prevSelect = _ref3.select;
      var _this$props = this.props,
          select = _this$props.select,
          onOpen = _this$props.onOpen,
          onClose = _this$props.onClose;

      if (prevSelect.state.isOpen !== select.state.isOpen) {
        select.state.isOpen ? onOpen && onOpen() : onClose && onClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _context2,
          _this2 = this;

      var _this$props2 = this.props,
          styles = _this$props2.styles,
          select = _this$props2.select,
          Option = _this$props2.Option,
          OptionNotFound = _this$props2.OptionNotFound,
          OptionSelected = _this$props2.OptionSelected,
          onOpen = _this$props2.onOpen,
          onClose = _this$props2.onClose,
          onScrollToBottom = _this$props2.onScrollToBottom,
          onOptionHover = _this$props2.onOptionHover,
          onOptionSelect = _this$props2.onOptionSelect,
          shouldCloseOnSelect = _this$props2.shouldCloseOnSelect,
          shouldCloseOnOuterClick = _this$props2.shouldCloseOnOuterClick,
          shouldEscapeClose = _this$props2.shouldEscapeClose,
          hideSelected = _this$props2.hideSelected,
          props = _objectWithoutProperties(_this$props2, ["styles", "select", "Option", "OptionNotFound", "OptionSelected", "onOpen", "onClose", "onScrollToBottom", "onOptionHover", "onOptionSelect", "shouldCloseOnSelect", "shouldCloseOnOuterClick", "shouldEscapeClose", "hideSelected"]);

      if (!select.state.isOpen) return null;
      /**
       * If hideSelected is true then we filter out the currently selected options. That way we are
       * only rendering options that are different from the ones we are already rendering as the
       * value of the Select.
       */

      var availableOptions = hideSelected ? _filterInstanceProperty(_context2 = select.state.options).call(_context2, function (option) {
        var _context3;

        var isSelected = _someInstanceProperty(_context3 = select.state.selected).call(_context3, function (selectedOption) {
          return select.helpers.pluckValue(option) === select.helpers.pluckValue(selectedOption);
        });

        return !isSelected;
      }) : select.state.options;
      var options;

      if (availableOptions.length > 0) {
        options = _mapInstanceProperty(availableOptions).call(availableOptions, function (option, currentIndex) {
          var _context4;

          var isSelected = _someInstanceProperty(_context4 = select.state.selected).call(_context4, function (selectedOption) {
            return select.helpers.pluckValue(option) === select.helpers.pluckValue(selectedOption);
          });

          var isActive = currentIndex === select.state.index;
          var OptionComponent = isSelected ? OptionSelected : Option;
          return React.createElement(OptionComponent, {
            key: select.helpers.pluckValue(option),
            index: currentIndex,
            option: option,
            term: select.state.value,
            pluckLabel: select.helpers.pluckLabel,
            isActive: isActive,
            onHover: _this2.handleOptionHover,
            onSelect: _this2.handleOptionSelect,
            scrollIntoView: _this2.scrollIntoView
          });
        });
      } else {
        options = [React.createElement(OptionNotFound, {
          key: 'not_found',
          term: select.state
        })];
      }

      return React.createElement("div", _extends({
        tabIndex: -1
      }, props, styles('container'), {
        ref: this.setRef,
        onKeyDown: this.handleKeyDown
      }), options);
    }
  }, {
    key: "setRef",
    value: function setRef(ref) {
      var innerRef = this.props.innerRef;

      if (innerRef && _.isFunction(innerRef)) {
        innerRef(ref);
      }

      this.el = ref;

      if (this.el) {
        this.el.removeEventListener('scroll', this.handleReachedBottom); // Setup manual scrolling for Options to utilise.

        this.Scroller = zenscroll.createScroller(this.el, 0, 0);
        this.el.addEventListener('scroll', this.handleReachedBottom);
      }
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(el) {
      if (this.Scroller) this.Scroller.intoView(el, 0);
    }
  }, {
    key: "handleOuterClick",
    value: function handleOuterClick(event) {
      var _this$props3 = this.props,
          select = _this$props3.select,
          shouldCloseOnOuterClick = _this$props3.shouldCloseOnOuterClick; // A menu is usually nested inside of a Select container, and that's
      // where we'd like to consider the start of 'inside' elements.

      var el = this.el && this.el.parentElement;

      if (shouldCloseOnOuterClick && select.state.isOpen && el && !el.parentElement.contains(event.target)) {
        this.props.select.actions.closeMenu();
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var keyCode = event.keyCode;
      var _this$props4 = this.props,
          select = _this$props4.select,
          shouldEscapeClose = _this$props4.shouldEscapeClose,
          onKeyDown = _this$props4.onKeyDown;
      if (onKeyDown) onKeyDown(event);
      if (event.defaultPrevented) return;

      switch (keyCode) {
        case KEY_CODES.ESCAPE:
          if (shouldEscapeClose && select.state.isOpen) {
            // Note: Blocks the escape from closing other components. eg Modals
            event.stopPropagation();
            select.actions.closeMenu();
          }

          break;

        default:
          break;
      }
    }
  }, {
    key: "handleReachedBottom",
    value: function handleReachedBottom(event) {
      var el = event.target;
      var onScrollToBottom = this.props.onScrollToBottom;
      var bottom = el.scrollTop;
      var max = el.scrollHeight - el.clientHeight;

      if (bottom === max) {
        onScrollToBottom(event);
      }
    }
  }, {
    key: "handleOptionHover",
    value: function handleOptionHover(activeIndex, option, event) {
      var _this$props5 = this.props,
          select = _this$props5.select,
          onOptionHover = _this$props5.onOptionHover;

      if (activeIndex !== select.state.index) {
        if (onOptionHover) onOptionHover(option, event);
        if (!event.defaultPrevented) select.actions.setIndex(activeIndex);
      }
    }
  }, {
    key: "handleOptionSelect",
    value: function handleOptionSelect(option, event) {
      var _this$props6 = this.props,
          select = _this$props6.select,
          onOptionSelect = _this$props6.onOptionSelect,
          shouldCloseOnSelect = _this$props6.shouldCloseOnSelect,
          shouldSelectResetInput = _this$props6.shouldSelectResetInput;
      if (onOptionSelect) onOptionSelect(option, event);

      if (!event.defaultPrevented) {
        event.stopPropagation();
        event.preventDefault();
        select.actions.pushSelected(option);
        if (shouldCloseOnSelect) select.actions.closeMenu();
        if (shouldSelectResetInput) select.actions.clearValue();
      }
    }
  }]);

  return SelectMenu;
}(Component), _defineProperty(_class2, "propTypes", {
  styles: Types.func,
  select: SelectModelPropType,
  innerRef: Types.func,

  /** Overridable Component */
  Option: ComponentPropType,

  /** Overridable Component */
  OptionNotFound: ComponentPropType,

  /** Overridable Component */
  OptionSelected: ComponentPropType,

  /** Label to use when there are no options matching the input term. */
  noResultsLabel: Types.string,

  /** Fires when the menu has opened: function () */
  onOpen: Types.func,

  /** Fires when the menu has closed: function () */
  onClose: Types.func,

  /** Fires when the menu has been scrolled to the bottom: function (event) */
  onScrollToBottom: Types.func,

  /** Fires when an Option has been hovered on (mouse/touch): function (option, event) */
  onOptionHover: Types.func,

  /** Fires when an Option has been selected (click/touch): function (option, event) */
  onOptionSelect: Types.func,

  /** Close the menu when an option is selected (click/touch) */
  shouldCloseOnSelect: Types.bool,

  /** Close the menu when outside the menu is close */
  shouldCloseOnOuterClick: Types.bool,

  /** Close the menu when Esc key is pressed: */
  shouldEscapeClose: Types.bool,

  /** Reset input on option selection */
  shouldSelectResetInput: Types.bool,

  /** Array of nodes that when clicked on will close the menu */
  outerClickListeners: Types.arrayOf(Types.object)
}), _defineProperty(_class2, "defaultProps", {
  innerRef: _.noop,
  Option: Option,
  OptionNotFound: OptionNotFound,
  OptionSelected: OptionSelected,
  onOpen: _.noop,
  onClose: _.noop,
  onScrollToBottom: _.noop,
  onOptionHover: _.noop,
  onOptionSelect: _.noop,
  shouldCloseOnSelect: true,
  shouldCloseOnOuterClick: true,
  shouldEscapeClose: false,
  hideSelected: false,
  outerClickListeners: [window]
}), _temp)) || _class) || _class) || _class);
SelectMenu.displayName = 'SelectMenu';
export default SelectMenu;